import { NumericBoolean } from '@bilibili-maoer/web-utils'

import { Outlet } from 'react-router-dom'
import { useMount } from 'react-use'

import { Box } from '@mui/material'

import { NotFound } from '../not-found'

import { useAppDispatch } from '~/app/hooks'
import { Sidebar } from '~/core/components/sidebar'
import { Routes } from '~/core/components/sidebar-nav'
import UiSlice from '~/core/slices/ui'
import { EAnnouncementType } from '~/features/announcements/types'
import { UserApi } from '~/services/fm/user'
import { NewsApi } from '~/services/web/news'
import { EGuildRole } from '~/shared/types/services/user'

const getRoutes = (checkIsRole: (role: EGuildRole) => boolean, notice?: NumericBoolean): Routes => [
  {
    to: '/guild/manage',
    text: '主播管理',
    check: () => checkIsRole(EGuildRole.Owner) || checkIsRole(EGuildRole.Agent) || checkIsRole(EGuildRole.Member),
  },
  {
    to: '/guild/report',
    text: '数据中心',
    check: () => checkIsRole(EGuildRole.Owner) || checkIsRole(EGuildRole.Agent),
  },
  {
    to: '/guild/income',
    text: '公会收益',
  },
  {
    to: '/guild/applyment',
    text: '签解约管理',
  },
  {
    to: '/guild/agents',
    text: '经纪人管理',
    check: () => !!checkIsRole(EGuildRole.Owner),
  },
  {
    to: '/guild/recommend',
    text: '资源位管理',
  },
  {
    to: '/guild/announcements',
    text: '公告',
    notice,
    check: () => checkIsRole(EGuildRole.AgentOrOwner),
  },
  {
    to: '/guild',
    text: '加入公会',
    check: () => !(checkIsRole(EGuildRole.AgentOrOwner) || checkIsRole(EGuildRole.Member)),
  },
]

export module GuildIndex {
  export const Layout = () => {
    const dispatch = useAppDispatch()

    useMount(() => {
      dispatch(UiSlice.actions.expandSidebar())
    })

    const { data: userInfo } = UserApi.getUserInfo.useQuery()
    const { data } = UserApi.getUserGuildRole.useQuery()
    const { data: noticeData } = NewsApi.getNotice.useQuery({
      tag_ids: [EAnnouncementType.LiveGuildTag, EAnnouncementType.LiveLiverTag, EAnnouncementType.LiveTag],
    })

    function isRole(role: EGuildRole): boolean {
      // eslint-disable-next-line no-bitwise
      return !!((data?.role || 0) & role)
    }

    if (!data) {
      return null
    }

    if (userInfo?.user?.user_id && (isRole(EGuildRole.Agent) || isRole(EGuildRole.Owner))) {
      return (
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ flex: 'none' }}>
            <Sidebar
              routes={getRoutes(isRole, noticeData?.data?.notices[EAnnouncementType.LiveGuildTag])}
              showUserInfo
            />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Outlet />
          </Box>
        </Box>
      )
    }

    return <NotFound />
  }
}
